import * as React from 'react';
import {Create, SimpleForm, BooleanInput, ReferenceInput, SelectInput, required} from 'react-admin';
import {CustomToolbar} from '../../components/customtoolbar/customToolbar.component';
import {Box, Grid} from '@mui/material';
import {LocalizedTitleInputs} from '../../components/localizedTitleInputs/localizedTitleInputs.component';

export const RiskCreate = () => {
  return (
    <Create
      children={
        <SimpleForm
          toolbar={<CustomToolbar noDelete />}
          children={
            <>
              <Grid container width="100%" spacing={1}>
                <Grid item xs={8}>
                  <Box display="flex">
                    <Box flex={1} mr={1}>
                      <LocalizedTitleInputs />
                    </Box>
                    <Box flex={1} ml={1}>
                      <ReferenceInput source="riskTemplateId" reference="riskTemplates">
                        <SelectInput optionText="title" validate={[required()]} />
                      </ReferenceInput>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
              <Grid item xs={8}>
                <ReferenceInput source="riskCategoryId" reference="riskCategories">
                  <SelectInput
                    optionText="displayName"
                    emptyText="Ingen kategori"
                    emptyValue=""
                    parse={value => (value === '' ? null : value)}
                    fullWidth
                  />
                </ReferenceInput>
              </Grid>
              <BooleanInput source="startActive" />
            </>
          }
        />
      }
    />
  );
};
